import { ANALYTICS_API_NAME, EVENT_MAPPING, ANALYTICS_EVENT_NAME } from '../spnAnalytics/analyticsEnum';
class AppSessionStart {
    /**
     * The constructor function is called when the object is created, and it's used to set up the
     * object.
     * @param obj @type {Object} - get global class object
     */
    constructor(obj) {
        this.queueManager = obj.queueManager;

        this.aspMandateFields = [
            EVENT_MAPPING.app_user_id,
            EVENT_MAPPING.app_device_id,
            EVENT_MAPPING.app_user_agent,
            EVENT_MAPPING.app_event_type,
            EVENT_MAPPING.app_session_id,
            EVENT_MAPPING.app_subscribe_type,
            EVENT_MAPPING.app_platform_type,
            EVENT_MAPPING.app_partner_id,
            EVENT_MAPPING.app_version,
            EVENT_MAPPING.app_build_version,
            EVENT_MAPPING.app_geo_location,
            EVENT_MAPPING.app_hardware,
            EVENT_MAPPING.app_operating_system,
        ];
        this.eventMandateFields = [
            EVENT_MAPPING.event_event_type,
            EVENT_MAPPING.event_wall_clock,
            EVENT_MAPPING.event_time_zone
        ];
        this.customMandateFields = [];
    }

    /**
     * It takes an object as a parameter and checks if the object has the properties that are in the
     * arrays aspMandateFields, eventMandateFields, and customMandateFields. If the object doesn't have
     * the property, it adds it to the object with an empty string as the value.
     * </code>
     * @param params @type {json} - event data
     * @returns An object with three properties: asp, event, and custom_tags.
     */
    checkMandatoryFields(params) {
        let attr = {};
        attr.asp = {};
        attr.event = {};
        attr.custom_tags = {};
        for (let i = 0; i < this.aspMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.aspMandateFields[i])) {
                attr.asp[this.aspMandateFields[i]] = "";
            } else {
                attr.asp[this.aspMandateFields[i]] = params[this.aspMandateFields[i]];
            }
        }

        for (let i = 0; i < this.eventMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.eventMandateFields[i])) {
                attr.event[this.eventMandateFields[i]] = "";
            } else {
                attr.event[this.eventMandateFields[i]] = params[this.eventMandateFields[i]];
            }
        }

        for (let i = 0; i < this.customMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.customMandateFields[i])) {
                attr.custom_tags[this.customMandateFields[i]] = "";
            } else {
                attr.custom_tags[this.customMandateFields[i]] = params[this.customMandateFields[i]];
            }
        }

        params.custom_tags = params.custom_tags || {};
        attr.custom_tags = { ...attr.custom_tags, ...params.custom_tags };

        return attr;
    }

    /**
     * "This function is used to get the firebase analytics events and pass the data in local storage."
     * </code>
     * @param eventName @type {string} - event name
     * @param eventData @type {json} - event data
     */
    getFireAppSessionStartEvents(eventName, eventData) {
        if (eventData != null && Object.keys(eventData).length > 0) {
            let attr = this.checkMandatoryFields(eventData);

            attr.asp[EVENT_MAPPING.app_hardware] = attr.asp[EVENT_MAPPING.app_hardware] == "" ? "und" : attr.asp[EVENT_MAPPING.app_hardware];
            attr.asp[EVENT_MAPPING.app_operating_system] = attr.asp[EVENT_MAPPING.app_operating_system] == "" ? "und" : attr.asp[EVENT_MAPPING.app_operating_system];

            attr.asp[EVENT_MAPPING.app_event_type] = ANALYTICS_EVENT_NAME.APP_APP_SESSION_START;
            attr.event[EVENT_MAPPING.event_event_type] = ANALYTICS_EVENT_NAME.EVENT_APP_SESSION_START;
            /**
             * pass data in local storage
             */
            this.queueManager.nextStoragePostData(ANALYTICS_API_NAME.APP_SESSION_START, eventName, attr);
        } else {
            SPN_Console.log("error getting");
        }
    }
}
export default AppSessionStart;

